import biLogger from '@wix/web-bi-logger';
import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';

import { BLOG_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import Wix, { EMPTY_GUID } from '../services/wix-sdk-polyfill';
import { getPreviousLocation, getCurrentLocation } from '../selectors/location-history-selectors';
import { getConfig } from '../services/config';
import { getInstance } from '../services/wix-sdk-utils';

export const getEventOrigin = ({ detectRoute, state, event }) => {
  const location = event.eventMeta.isNavigation ? getPreviousLocation(state) : getCurrentLocation(state);
  return detectRoute(location);
};

export const createBi = ({ endpoint, src, instanceId }) => {
  const defaults = {
    src,
    app_id: BLOG_APP_ID,
    community_id: undefined, // TODO implement
    instance_id: getConfig().instanceId || instanceId,
    original_instance_id: undefined, // TODO implement
  };
  if (defaults.instance_id === EMPTY_GUID) {
    delete defaults.instance_id;
  }

  return biLogger
    .factory({ endpoint })
    .setDefaults(defaults)
    .logger();
};

export const createUouBi = ({ endpoint, src, useBeacon = true }) =>
  iframeAppBiLoggerFactory(Wix, { endpoint, useBeacon })
    .updateDefaults({
      src,
      app_id: BLOG_APP_ID,
      app_site_id: Wix.Utils.getInstanceId(),
      instance_id: Wix.Utils.getInstanceId(),
    })
    .logger();

export const hasBiToken = event => event.biToken || event.msid;

export const getInstanceValue = key => (getInstance() ? Wix.Utils.getInstanceValue(key) : undefined);
